<div class="login-container" style="">
  <div class="title">
    <span class="word-title">LOGO</span>
       <!-- <img src="assets/imgs/ADCLOGO.jpg" height="110" width="120" style="margin-left: -90%;"/> -->
  </div>
  <form nz-form [formGroup]="validateForm" class="login-form" (ngSubmit)="submitForm()">
    <nz-form-item>
      <nz-form-control nzErrorTip="请输入用户名!">
        <!--        nzPrefixIcon="user"-->
        <nz-input-group>
          <img src="assets/imgs/login_account.png" alt="" width="15"
               style="position: absolute;left: 10px;top:10px;z-index: 9"/>
          <input class="input-class" type="text" nz-input [(ngModel)]="userName" style="padding-left: 35px"
                 formControlName="userName" placeholder="Abbott 511 ID"/>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control nzErrorTip="请输入密码!">
        <nz-input-group>
          <img src="assets/imgs/login_psw.png" alt="" width="15"
               style="position: absolute;left: 10px;top:10px;z-index: 9"/>
          <input class="input-class" type="password" nz-input [(ngModel)]="password" style="padding-left: 35px"
                 formControlName="password" placeholder="Window login password"/>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <!--        <label nz-checkbox>-->
        <!--          <span>Remember me</span>-->
        <!--        </label>-->
        <!--        <a class="login-form-forgot" class="login-form-forgot">Forgot password</a>-->
        <!--        [nzLoading]="isLoading"-->
        <label>
          <span>
            请使用雅培电脑开机账号(511ID)和密码登录
          </span>
        </label>
        <button nz-button class="login-form-button" [nzType]="'primary'" [nzShape]="'round'">
          登录
        </button>
        <!--        <nz-spin nzTip="加载中..." [nzSize]="'large'" [nzSimple]="true" *ngIf="isLoading"></nz-spin>-->
        <!--        <a>register now!</a>-->
      </nz-form-control>
    </nz-form-item>
  </form>
  <!-- <div class="copyright-word">
    2010-2022 @上海软素科技股份有限公司 版权所有沪ICP备 11017254号-8
  </div> -->
</div>
